import React, { Component } from "react";
import PropTypes from "prop-types";
import FormLabel from "../styledElements/label";
import { rangePropType, valuePropType } from "../styledElements/rangePropTypes";
import "react-input-range/lib/css/index.css";
import InputError from "../styledElements/inputError";
import StyledRange from "../styledElements/styledRange";
class Range extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value,
        };
    }

    handleChange(value) {
        this.setState({
            value: value,
        });
        return this.props.onChange({
            name: this.props.name,
            value: value,
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.setState({
                value: this.props.value,
            });
        }
    }

    render() {
        const { label, name, value, onChange, error, ...rest } = this.props;

        return (
            <div>
                {label && (
                    <FormLabel
                        name={name}
                        label={label}
                        {...this.props}
                        marginBottom={1.2}
                    >
                        {label}
                    </FormLabel>
                )}
                {this.props.easyRead && <b>{this.props.easyRead}</b>}

                <StyledRange
                    value={this.state.value}
                    onChange={this.handleChange.bind(this)}
                    {...rest}
                />
                <br />

                <InputError error={error} />
            </div>
        );
    }
}

Range.propTypes = {
    ariaLabelledby: PropTypes.string,
    ariaControls: PropTypes.string,
    classNames: PropTypes.objectOf(PropTypes.string),
    disabled: PropTypes.bool,
    draggableTrack: PropTypes.bool,
    formatLabel: PropTypes.func,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    maxValue: rangePropType,
    minValue: rangePropType,
    name: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onChangeStart: PropTypes.func,
    onChangeComplete: PropTypes.func,
    step: PropTypes.number,
    value: valuePropType,
    error: PropTypes.string,
};

Range.defaultProps = {
    error: "",
};

export default Range;
